// src/components/Report/RangeBar.js
// Date-range chips (Today / 7 Days / …) + custom From–To date inputs.
import React from 'react';
import { formatDateKey } from '../../utils/attendanceFormat';
import '../../pages/Shared/ReportPages.css';

const RangeBar = ({ presets, range, onRange, from, to, onFrom, onTo }) => {
  const today = formatDateKey();
  return (
    <div className="rp-toolbar">
      <div className="rp-chips">
        {presets.map((p) => (
          <button
            key={p.key}
            type="button"
            className={`rp-chip ${range === p.key ? 'active' : ''}`}
            onClick={() => onRange(p.key)}
          >
            {p.label}
          </button>
        ))}
      </div>

      {range === 'custom' && (
        <div className="rp-dates">
          <input
            type="date"
            className="rp-input"
            value={from}
            max={today}
            onChange={(e) => onFrom(e.target.value)}
          />
          <span>to</span>
          <input
            type="date"
            className="rp-input"
            value={to}
            max={today}
            min={from || undefined}
            onChange={(e) => onTo(e.target.value)}
          />
        </div>
      )}
    </div>
  );
};

export default RangeBar;

//------------ 13.10.26 Backup -----------------------
// // src/components/Report/RangeBar.js
// // Date-range chips (Today / 7 Days / …) + custom From–To date inputs.
// import React from 'react';
// import { formatDateKey } from '../../utils/attendanceFormat';
// import '../../pages/Shared/ReportPages.css';

// const RangeBar = ({ presets, range, onRange, from, to, onFrom, onTo }) => {
//   const today = formatDateKey();
//   return (
//     <div className="rp-toolbar">
//       <div className="rp-chips">
//         {presets.map((p) => (
//           <button
//             key={p.key}
//             type="button"
//             className={`rp-chip ${range === p.key ? 'active' : ''}`}
//             onClick={() => onRange(p.key)}
//           >
//             {p.label}
//           </button>
//         ))}
//       </div>

//       {range === 'custom' && (
//         <div className="rp-dates">
//           <input
//             type="date"
//             className="rp-input"
//             value={from}
//             max={today}
//             onChange={(e) => onFrom(e.target.value)}
//           />
//           <span>to</span>
//           <input
//             type="date"
//             className="rp-input"
//             value={to}
//             max={today}
//             min={from || undefined}
//             onChange={(e) => onTo(e.target.value)}
//           />
//         </div>
//       )}
//     </div>
//   );
// };

// export default RangeBar;
